import { useContext, useState } from "react";
import { Col, Container, Row, Button, Card, CardBody, CardHeader } from "reactstrap";
import { Link } from 'react-scroll';
import logoSoal from '../../../assets/images/game/w2_assets/Questionbar.png'
import Pilihan1 from '../../../assets/images/game/w2_soal/no-3/soal-3-left.png'
import Pilihan2 from '../../../assets/images/game/w2_soal/no-3/soal-3-right.png'
import { Context } from "../../../contexts/reducer/store";
import CheckAnswer from "../CheckAnswer";

import AnswerTrue from '../../../assets/images/game/w2_soal/no-3/soal no 3.png'
import AnswerFalse from '../../../assets/images/game/w2_soal/no-3/soal no 3.png'

import hiasan12 from '../../../assets/images/game/w2_assets/Asset-71.png'
import hiasan13 from '../../../assets/images/game/w2_assets/Asset-79-2.png'
import hiasan14 from '../../../assets/images/game/w2_assets/AdkBQM-small.png'
import Left from '../../../assets/images/game/w2_assets/question-title-left.png';
import Right from '../../../assets/images/game/w2_assets/question-title-right.png';

const Soal3 = () => {

    let [isOpen, setIsOpen] = useState(false)
    let [isTrue, setIsTrue] = useState(false)

    const [state, dispatch] = useContext(Context);
    const [disabled, setDisabled] = useState(false)


    function toggleModal ( type ) {
        setIsOpen(!isOpen);
        setIsTrue(type);
        setDisabled(true)
    }

    function SET_MARK ( value = Number ) {
        const init = {...state};
        let __mark = init.mark
        dispatch({type: 'SET_MARK', payload: __mark + value});
    }

    const Answer = () => {
        return (
            <>
                <div className={`${isTrue ? 'd-none' : 'd-block'} text-center`}>
                    <small>Berikut Penjelasan masing-masing pilihan jawaban :</small>
                </div>
                <img className="img-fluid" src={isTrue ? AnswerTrue : AnswerFalse} alt="" />
                <div className={`bg-light-green text-center py-1 ${isTrue ? 'd-none' : 'd-block'} my-3`}>
                    Jawaban yang benar pada soal adalah <b>Koneksi yang salah.</b>
                </div>
            </>
        )
    }

    return (
        <>
            <Container className="front">
                <CheckAnswer Type={isTrue} isOpen={isOpen} setIsOpen={setIsOpen}>
                    <Answer />
                </CheckAnswer>
                <Row>
                    <Col md="12" className="text-center game-px position-relative">
                        <Row className="mb-5">
                            <Col lg="1" md="1" sm="1" xs="1" className="p-0 my-auto">
                                <img src={Left} alt="" />
                            </Col>
                            <Col lg="10" md="10" sm="10" xs="10" className="my-auto">
                                <Card className="card-title-quiz">
                                    <CardBody>
                                        <h2 className="judul-game-4 montserrat">
                                            KONTEN YANG MEMILIKI <b>JUDUL, ISI KONTEN,<br />
                                            GAMBAR HINGGA VIDEO YANG TIDAK<br />
                                            MENDUKUNG ISI KONTEN</b><br />
                                            TERMASUK DALAM JENIS HOAKS APA?
                                        </h2>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg="1" md="1" sm="1" xs="1" className="p-0 my-auto">
                                <img src={Right} alt="" />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col md="12">
                                <Card className="card-game">
                                    <CardHeader className="bg-soal-pink text-center">
                                        <b>CONTOH KONTEN KLAIM HOAKS YANG DITANYAKAN</b>
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                            <Col md="6" className="text-center q2-col">
                                                <span className="judul-pilihan-soal-2">KLAIM HOAKS</span>
                                                <div className="pt-4">
                                                    <img src={Pilihan1} alt="klaim-hoaks" className="img-fluid" />
                                                </div>
                                                <div className="pt-4">
                                                    <p className="desc-soal3 montserrat">
                                                        Menampilkan klaim video Gubernur Jawa Barat<br />
                                                        (Jabar) <b>Ridwan Kamil sedang menari<br />
                                                        merayakan pesta kemenangan<br />
                                                        Pekan Olahraga Nasional (PON) XX </b><br />
                                                        <br />
                                                        TETAPI<br />
                                                        <br />
                                                        <b>Tidak menjalankan protokol kesehatan.</b>
                                                    </p>
                                                </div>
                                            </Col>
                                            <Col md="6" className="text-center">
                                                <span className="judul-pilihan-soal-2">FAKTANYA</span>
                                                <div className="pt-4">
                                                    <img src={Pilihan2} alt="klaim-hoaks" className="img-fluid" />
                                                </div>
                                                <div className="pt-4">
                                                    <p className="desc-soal3 montserrat">
                                                        Ridwan Kamil menjelaskan video tersebut <br />
                                                        <b>bukanlah video menari merayakan kemenangan <br /> Jabar di PON Papua XX </b> <br />
                                                        <br />
                                                        TETAPI<br />
                                                        <br />
                                                        <b>
                                                            Merayakan keberagaman Cap Go Meh di Kota Bogor sebelum pandemi.
                                                        </b>
                                                    </p>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        {
                            disabled === false
                            ? <Row className="pt-3">
                                    <Col md="6" className="text-center p-0 pt-3">
                                        <Link to="q4" spy={true} smooth={true} className="btn btn-jawaban montserrat" onClick={() => (toggleModal(false))}>KONTEN YANG SALAH</Link >
                                    </Col>
                                    <Col md="6" className="text-center p-0 pt-3">
                                        <Link to="q4" spy={true} smooth={true} className="btn btn-jawaban montserrat" onClick={() => (toggleModal(false))}>SATIRE/PARODI</Link >
                                    </Col>
                                    <Col md="6" className="text-center p-0 pt-3">
                                        <Link to="q4" spy={true} smooth={true} className="btn btn-jawaban montserrat" onClick={() => (toggleModal(false))}>KONTEN YANG MENYESATKAN</Link >
                                    </Col>
                                    <Col md="6" className="text-center p-0 pt-3">
                                        <Link to="q4" spy={true} smooth={true} className="btn btn-jawaban montserrat" onClick={() => (toggleModal(true), SET_MARK(1))}>KONEKSI YANG SALAH</Link >
                                    </Col>
                                </Row>
                            : <Row className="pt-3">
                                <Col md="6" className="text-center p-0 pt-3">
                                    <button className="btn btn-jawaban montserrat" disabled>KONTEN YANG SALAH</button >
                                </Col>
                                <Col md="6" className="text-center p-0 pt-3">
                                    <button className="btn btn-jawaban montserrat" disabled>SATIRE/PARODI</button >
                                </Col>
                                <Col md="6" className="text-center p-0 pt-3">
                                    <button className="btn btn-jawaban montserrat" disabled>KONTEN YANG MENYESATKAN</button >
                                </Col>
                                <Col md="6" className="text-center pt-3">
                                    <button className="btn btn-jawaban montserrat" disabled>KONEKSI YANG SALAH</button >
                                </Col>
                            </Row>
                        }
                    </Col>
                </Row>
            </Container>
            <div className="position-relative img-asset">
                <img src={hiasan12} className="asset-12" />
                <img src={hiasan13} className="asset-13" />
                <img src={hiasan14} className="asset-14" />
            </div>
        </>
    )
}

export default Soal3